import { render } from "./stats.vue?vue&type=template&id=8393504a&scoped=true&ts=true"
import script from "./stats.vue?vue&type=script&lang=ts"
export * from "./stats.vue?vue&type=script&lang=ts"

import "./stats.vue?vue&type=style&index=0&id=8393504a&scoped=true&lang=css"

import exportComponent from "/home/debian/dev/meteostatik/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8393504a"]])

export default __exports__